import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import ConfigManager from '../../../common/configManager/configManager';
import { prettyMatchUrl } from '../../../common/rcs_gaz_mc_core_FE';
import IconFont from '../../shared/IconFont';
import * as status from '../../../constants';
import {
  Spacer,
  GameTop,
  GameSpacer,
  GameBottom,
  LegConatiner,
  TeamLogo,
  TeamName,
  ResultHome,
  ResultAway,
  ArrowSeparator,
  MatchLinkWrapper,
} from '../styles';

class Tabellone extends Component {
  classLink = (matchRow) => {
    const homeCode = matchRow.homeTeam.teamCode;
    const awayCode = matchRow.awayTeam.teamCode;
    let returnedClass = '';
    if (homeCode && awayCode && homeCode.length < 3 && awayCode.length < 3) {
      returnedClass = 'no-event';
    }
    if (homeCode && awayCode && Number(homeCode[homeCode.length - 1]) && Number(awayCode[awayCode.length - 1])) {
      returnedClass = 'no-event';
    }
    return returnedClass;
  };

  resultHome = (match) => {
    if (match.status === status.PREMATCH_STATUS) {
      return '-';
    }
    if (match.resultType === 'PenaltyShootout') {
      if (match.homeTeam.starData.hasOwnProperty('shootOuts')) {
        return Number(match.homeTeam.score) + Number(match.homeTeam.starData.shootOuts.score);
      }
    }
    return match.homeTeam.score;
  };

  resultAway = (match) => {
    if (match.status === status.PREMATCH_STATUS) {
      return '-';
    }
    if (match.resultType === 'PenaltyShootout') {
      if (match.awayTeam.starData.hasOwnProperty('shootOuts')) {
        return Number(match.awayTeam.score) + Number(match.awayTeam.starData.shootOuts.score);
      }
    }
    return match.awayTeam.score;
  };

  render() {
    const {
      match, i, round, moveTo,
    } = this.props;
    const imagesURL = ConfigManager.getFootballTeams('min');
    let showTeamLogo = true;
    let logoHome;
    let logoAway;
    if (match.homeTeam && match.awayTeam) {
      logoHome = `${imagesURL}${match.homeTeam.teamId}.png`;
      logoAway = `${imagesURL}${match.awayTeam.teamId}.png`;
    } else {
      showTeamLogo = false;
    }
    let position = 'odd';
    if (i % 2 === 0) {
      position = 'even';
    }

    let isLast = '';
    if (round === 3) {
      isLast = 'isSecondLast';
    } else if (round === 4) {
      isLast = 'isLast';
    }

    const awayResPen = (match.awayTeam.starData.shootOuts && match.awayTeam.starData.shootOuts.score) ?
      match.awayTeam.starData.shootOuts.score : 0;
    const homeResPen = (match.homeTeam.starData.shootOuts && match.homeTeam.starData.shootOuts.score) ?
      match.homeTeam.starData.shootOuts.score : 0;

    const isHomeWinner = () => (Number(match.homeTeam.score) + Number(homeResPen))
      > (Number(match.awayTeam.score)) + Number(awayResPen) && match.status !== 'LIVE';
    const isAwayWinner = () => (Number(match.homeTeam.score) + Number(homeResPen))
      < (Number(match.awayTeam.score) + Number(awayResPen)) && match.status !== 'LIVE';

    const currentRound = `round-${round}`;
    return [
      <Spacer key={0}>&nbsp;</Spacer>,
      <MatchLinkWrapper
        key={1}
        className={this.classLink(match)}
        href={`${prettyMatchUrl(match.homeTeam.teamName, match.awayTeam.teamName, match.matchId, 1, this.props.competitionId, this.props.newspaper)}`}
      >
        <GameTop>
          {(match.homeTeam && match.awayTeam) &&
            <LegConatiner>
              {showTeamLogo && <LazyLoad once><TeamLogo src={logoHome} /></LazyLoad>}
              <TeamName weight={isHomeWinner(match.homeTeam.teamName) ? 'bold' : ''}>{match.homeTeam.teamName}</TeamName>
              <ResultHome weight={isHomeWinner(match.homeTeam.teamName) ? 'bold' : ''}>{this.resultHome(match)}</ResultHome>
            </LegConatiner>
          }
        </GameTop>
        <span>
          {!this.props.isMobile &&
            <GameSpacer className={`${position} ${currentRound} ${isLast}`}>&nbsp;</GameSpacer>
          }
        </span>
        <GameBottom>
          {(match.homeTeam && match.awayTeam) &&
            <LegConatiner>
              {showTeamLogo && <LazyLoad once><TeamLogo src={logoAway} /></LazyLoad>}
              <TeamName weight={isAwayWinner(match.homeTeam.teamName) ? 'bold' : ''}>{match.awayTeam.teamName}</TeamName>
              <ResultAway weight={isAwayWinner(match.homeTeam.teamName) ? 'bold' : ''}>{this.resultAway(match)}</ResultAway>
            </LegConatiner>
          }
        </GameBottom>
      </MatchLinkWrapper>,
      <li
        className="ArrowSeparator"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
        key={2}
      >
        {this.props.isMobile &&
          <ArrowSeparator
            onClick={(e) => {
              moveTo(e.target.parentNode.parentNode.parentNode.previousSibling.offsetLeft - 10);
            }}
            className="ArrowSeparatorLeft"
          >
            <IconFont
              className="icon-matchcenter-back-arrow"
              color="buttonColor"
              font="10px"
              padding="10px 10px 10px 0px"
            />
          </ArrowSeparator>
        }
        {this.props.isMobile &&
          <ArrowSeparator
            onClick={(e) => {
              moveTo(e.target.parentNode.parentNode.parentNode.nextSibling.offsetLeft - 10);
            }}
            className="ArrowSeparatorRight"
            rotation
          >
            <IconFont
              className="icon-matchcenter-back-arrow"
              color="buttonColor"
              font="10px"
              padding="10px 10px 10px 0px"
            />
          </ArrowSeparator>
        }
      </li>,
    ];
  }
}

Tabellone.propTypes = {
  match: PropTypes.any,
  i: PropTypes.any,
  round: PropTypes.any,
  competitionId: PropTypes.any,
  isMobile: PropTypes.bool,
  newspaper: PropTypes.any,
  moveTo: PropTypes.any,
};

export default Tabellone;



// WEBPACK FOOTER //
// ./src/components/PlayOffChart/Tabellone/index.js